import React from 'react';
import RefLastResults from '../resultPoker/RefLastResults';
import Poker6ResultBody from '../../../casinoComponents/refResultModal/Poker6ResultBody';

// Reference: <span class="resulttie"> with T (win 0) or the player number (win 11..16 → 1..6)
const item = (win) => {
  const n = Number(win);
  return { cls: 'resulttie', text: win === '0' ? 'T' : n >= 11 && n <= 16 ? String(n - 10) : '' };
};

/** Last Result items + result modal for Poker 6 Players (poker6), reference markup. */
const ResultPoker6 = ({ data = [], gameType = 'poker6' }) => (
  <RefLastResults
    apiType={(gameType || 'poker6').toLowerCase().trim()}
    data={data}
    item={item}
    renderBody={(t1) => <Poker6ResultBody t1={t1} />}
    fallbackTitle="Poker 6 Players"
  />
);

export default ResultPoker6;
